import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    title: 'Cómo Vender Amigurumis Personalizados y Cobrar Precio Premium',
    description: 'Guía para emprendedoras: aprende a ofrecer mascotas por raza como servicio exclusivo y diferenciarte del resto.',
    color: 'from-amber-50 to-orange-50',
    tag: 'Para emprendedoras'
  }, {
    title: 'Pack Amigos de Kitty',
    description: 'Colección especial de patrones inspirados en los personajes más tiernos. Perfectos para regalar o vender.',
    color: 'from-pink-50 to-rose-50',
    tag: 'Patrones extra'
  }, {
    title: 'Patrones Gatitos Halloween',
    description: 'Gatitos con temática de Halloween: calabazas, brujitas y fantasmitas. Ideales para temporada.',
    color: 'from-orange-50 to-amber-50',
    tag: 'Edición especial'
  }, {
    title: 'Gatitos Cactus',
    description: 'La combinación más adorable: gatitos disfrazados de cactus. Un diseño único que encanta a todos.',
    color: 'from-green-50 to-emerald-50',
    tag: 'Edición especial'
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-15">
      <div className="max-w-5xl mx-auto px-4" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-17">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-cream rounded-full mb-5" data-id="element-18">
            <Gift size={16} className="text-soft-rose" data-id="element-19" />
            <span className="text-sm font-bold text-warm-brown" data-id="element-20">
              Bonos incluidos
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown mb-3" data-id="element-21">
            Y además, te llevas estos regalos
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto" data-id="element-22">
            Bonos exclusivos que complementan tu colección y te dan aún más
            valor.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-23">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="etsy-card etsy-card-hover overflow-hidden flex flex-col sm:flex-row" data-id="element-24">
              {/* Square Image Placeholder */}
              <div className={`sm:w-40 w-full aspect-square sm:aspect-auto flex-shrink-0 bg-gradient-to-br ${bonus.color} flex items-center justify-center relative`} data-id="element-25">
                <span className="text-4xl opacity-30 font-heading font-bold text-deep-brown select-none" data-id="element-26">
                  {index + 1}
                </span>
                <div className="absolute top-3 left-3" data-id="element-27">
                  <span className="text-[10px] font-bold uppercase tracking-wider bg-white/80 backdrop-blur-sm px-2 py-1 rounded-full text-warm-brown" data-id="element-28">
                    {bonus.tag}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-5 flex flex-col justify-center" data-id="element-29">
                <h3 className="font-bold text-deep-brown mb-2 leading-snug" data-id="element-30">
                  {bonus.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-31">
                  {bonus.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}